<template>
  <div class="admin-register">
    <b-container fluid="lg">
      <b-card class="shadow" no-body>
        <b-row no-gutters>
          <b-col md="5" lg="5" xl="5">
            <div class="image-background">
              <div class="dark-overlay"></div>  
            </div>
            <div class="content-info">
              <img
                fetchpriority="high"
                src="/images/sistemacpv_white.png"
                alt="Logo Sistema CPV"
                width="65px"
                height="auto"
              />
              <div class="box-text my-5">
                <span class="text-uppercase display-6 text-white font-weight-bold">{{ escola }}</span>
                <hr>
                 <p class="text-white">
                  Para cadastrar o professor, informe os dados ao lado. O cadastro é necessário para que ele tenha
                  acesso ao <strong>Sistema CPV</strong>. A modalidade define as permissões e deve ser vinculada ao
                  professor, permitindo assim o acesso ao <strong>Conteúdo Exclusivo do Sistema CPV &copy;</strong>
                </p>
                <p class="text-white mb-3">
                  O cadastro de professores é limitado de acordo com os serviços contratados. Para mais informações
                  entre em contato com o <strong>Sistema CPV &copy;</strong>
                </p>
                <b-button class="btn-professor my-4" variant="transparent" @click="getprofessors()" hidden>
                  Buscar professor
                </b-button>
              </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="7" lg="7" xl="7">
            <form class="box-form" action="javascript:void(0)" method="post">
              <b-form-row>
                <b-col cols="12" sm="12" md="7" lg="7" xl="7">
                  <b-form-group label-for="user-fullname">
                    <div class="input-container">
                      <i class="fas fa-user icon"></i>
                      <b-form-input
                        type="text"
                        id="user-fullname"
                        class="custom-input"
                        v-model="nome"
                        placeholder="Nome Completo"
                        autocomplete="off"
                        required
                      ></b-form-input>
                    </div>
                    <i small class="text-danger text-error" v-if="$v.nome.$error == true">Nome é obrigatório.</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="5" lg="5" xl="5">
                  <b-form-group label-for="user-gender">
                    <div class="input-container">
                      <i class="fas fa-venus-mars icon"></i>
                      <b-form-select
                        id="user-gender"
                        class="custom-input-select"
                        v-model="sexo"
                        :options="sexos"
                        value-field="value"
                        text-field="name"
                        required
                      >
                        <template #first>
                          <b-form-select-option disabled value="">Sexo</b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                    <i small class="text-danger text-error" v-if="$v.sexo.$error === true">Campo Sexo é obrigatório</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="5" lg="5" xl="5" class="my-1">
                  <b-form-group label-for="user-document">
                    <div class="input-container">
                      <i class="fas fa-id-card icon"></i>
                      <b-form-input
                        type="text"
                        id="user-document"
                        class="custom-input"
                        v-model="cpf"
                        v-mask="'###.###.###-##'"
                        placeholder="CPF"
                        autocomplete="off"
                      ></b-form-input>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="7" lg="7" xl="7" class="my-1">
                  <b-form-group label-for="user-email">
                    <div class="input-container">
                      <i class="fas fa-envelope icon"></i>
                      <b-form-input
                        type="email"
                        id="user-email"
                        class="custom-input"
                        v-model="email"
                        placeholder="E-mail"
                        autocomplete="off"
                        required
                      ></b-form-input>
                    </div>
                    <i class="text-danger text-error" v-if="$v.email.$error == true">E-mail obrigatório</i>
                    <i class="text-danger text-error" v-if="$v.email.$invalid == true && email.length > 3">Digite um e-mail valido.</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="my-1" v-if="!gerarSenhaAutomatico">
                  <b-form-group label-for="password">
                    <div class="input-container">
                      <i class="fas fa-lock-keyhole icon"></i>
                      <b-form-input
                        :type="chk ? 'text' : 'password'"
                        id="password"
                        class="custom-input"
                        v-model="password"
                        placeholder="Senha"
                        autocomplete="off"
                        required
                      ></b-form-input>
                      <i
                        class="icon-right"
                        :class="chk ? 'fas fa-eye-slash' : 'fas fa-eye'"
                        @click="chk = !chk"
                      ></i>
                    </div>
                    <i class="text-danger text-error" v-if="$v.password.$error === true">Campo senha é obrigatório</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="my-1" v-if="!gerarSenhaAutomatico">
                  <b-form-group label-for="confirm-password">
                    <div class="input-container">
                      <i class="fas fa-lock-keyhole icon"></i>
                      <b-form-input :type="c_chk ? 'text' : 'password'" id="confirm-password" class="custom-input" v-model="c_password" autocomplete="off" placeholder="Confirmar Senha" required></b-form-input>
                      <i class="icon-right" :class="c_chk ? 'fas fa-eye-slash' : 'fas fa-eye'" @click="c_chk = !c_chk"></i>
                    </div>
                    <i class="text-danger text-error" v-if="c_password && c_password !== password && !$v.c_password.sameAsPassword">As senhas não são iguais</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="my-1">
                  <b-form-group>
                    <div class="d-flex">
                      <b-form-checkbox class="mr-2" v-model="gerarSenhaAutomatico">{{
                        gerarSenhaAutomatico ? 'Gerar senha automática' : 'Criar uma senha'
                      }}</b-form-checkbox>
                      <b-form-checkbox class="ml-2" v-model="eh_professor">{{
                        eh_professor ? 'Perfil de Professor' : 'É Professor?'
                      }}</b-form-checkbox>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-1" v-if="eh_professor">
                  <b-form-group label-for="modelity-professor">
                    <div class="input-container">
                      <i class="fas fa-chalkboard-teacher icon"></i>
                      <b-form-select id="modelity-professor" class="custom-input-select" v-model="codigo_mod" :options="modalidadeNome" value-field="id" text-field="name" required>
                        <template #first>
                          <b-form-select-option disabled value="">Modalidade do Professor</b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                    <i class="text-danger text-error" v-if="$v.codigo_mod.$error == true && codigo_mod !== ''">Campo obrigatório</i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6" class="mt-1" v-if="eh_professor">
                  <b-form-group label-for="disciplina">
                    <div class="input-container">
                      <i class="fas fa-book icon"></i>
                      <b-form-select id="disciplina" class="custom-input-select" v-model="codigo_disciplina" :options="disciplinaNome" value-field="id" text-field="name" required>
                        <template #first>
                          <b-form-select-option disabled value="">Disciplina do Professor</b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" v-if="!eh_professor">
                  <b-form-group label-for="user-perfil">
                    <div class="input-container">
                      <i class="fas fa-id-badge icon"></i>
                      <b-form-select
                        id="user-perfil"
                        class="custom-input-select"
                        v-model="perfil"
                        :options="perfilNome"
                        value-field="value"
                        text-field="name"
                        required
                      >
                        <template #first>
                          <b-form-select-option disabled value="">Perfil do Usuário</b-form-select-option>
                        </template>
                      </b-form-select>
                    </div>
                    <i class="text-danger text-error" v-if="$v.perfil.$error"> Campo Perfil é obrigatório! </i>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="my-1">
                  <b-form-group label-for="checkout-termos-de-uso">
                    <b-form-checkbox id="checkout-termos-de-uso" v-model="chk_aceite">Concordo com os <a href="#">Termos de uso e Política de Privacidade</a> do Sistema CPV &copy;.</b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <transition type="animation" enter-active-class="animated animate__fadeIn" appear mode="in-out" v-if="userCreated">
                    <b-alert variant="success" show >
                      <strong>Usuário:</strong> {{ createdUser.name }} <br>
                      <!-- <strong>CPF:</strong> {{ createdUser.cpf }} <br> -->
                      <strong>E-mail:</strong> {{ createdUser.email }} <br>
                      <strong>Senha Gerada:</strong> {{ generatedPassword }}<br />
                      <b-button variant="primary" class="mt-2" v-b-modal.PermissionsUsersModal v-if="hasAdminRole">
                        Permissões
                      </b-button>
                    </b-alert>
                  </transition>
                  <transition type="animation" enter-active-class="animated animate__fadeIn" appear mode="in-out" v-if="showErrorToast && !userCreated">
                    <b-alert variant="danger" show>
                      <!-- <div v-for="(message, index) in errormessages" :key="index">
                        <p hidden>{{ message }}</p>
                      </div> -->
                      <strong>E-mail: {{ email }}</strong> já está cadastrado no sistema.
                    </b-alert>
                  </transition>
                  <transition type="animation" enter-active-class="animated animate__fadeIn" appear mode="in-out" v-if="eh_professor && showErrorToast && !userCreated">
                    <b-alert variant="warning" show >
                      Deseja vincular o usuário como professor na escola? <br>
                      <strong>Escola: </strong> {{ escola }} <br> 
                      <strong>Modalidade: </strong> {{ codigo_mod.name }}
                      <div class="w-100 d-flex justify-content-end mt-1">
                        <b-button-group size="sm">
                          <b-button class="p-2" variant="outline-danger">Cancelar</b-button>
                          <b-button class="p-2" variant="outline-primary" @click="associa()">Associar</b-button>
                        </b-button-group>
                      </div>
                    </b-alert>
                  </transition>
                  <transition type="animation" enter-active-class="animated animate__fadeIn" appear mode="in-out" v-if="!eh_professor && showErrorToast && !userCreated">
                    <b-alert variant="warning" show>
                      Deseja vincular o usuário como: <br>
                      <strong>Perfil:</strong> {{ perfil.name }} <br> 
                      <strong>Escola: {{ escola }}</strong>
                      <div class="w-100 d-flex justify-content-end mt-1">
                        <b-button-group size="sm">
                          <b-button class="p-2" variant="outline-danger">Cancelar</b-button>
                          <b-button class="p-2" variant="outline-primary" @click="associa()">Associar</b-button>
                        </b-button-group>
                      </div>
                    </b-alert>
                  </transition>
                </b-col>
                <b-col cols="12">
                  <hr>
                  <div class="d-flex align-items-center justify-content-between">
                    <b-button
                      type="button"
                      class="p-0 text-decoration-none text-dark"
                      :to="{ name: 'cadastro' }"
                      variant="link"
                      >Voltar</b-button>
                    <b-button
                      type="button"
                      class="btn-register"
                      variant="transparent"
                      :disabled="!chk_aceite"
                      @click="register()"
                      >Cadastrar</b-button>
                  </div>
                </b-col>
              </b-form-row>
            </form>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
        <b-modal id="PermissionsUsersModal" centered size="lg" ok-only>
      <b-col cols="12">
        <permission :userId="createdUserId" :companyId="company_id" :isEditing="true" v-if="hasAdminRole" />
      </b-col>
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { WOW } from 'wowjs'
  import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
  import { cpf } from 'cpf-cnpj-validator'
  import ApiService from '../../common/api.service'

  // Components do Bootstrap-Vue
  import { BCard } from 'bootstrap-vue'
  import { BFormGroup } from 'bootstrap-vue'
  import { BFormInput } from 'bootstrap-vue'
  import { BFormSelect } from 'bootstrap-vue'
  import { FormCheckboxPlugin } from 'bootstrap-vue'
  import { LayoutPlugin } from 'bootstrap-vue'

  Vue.component('b-card', BCard)
  Vue.component('b-form-group', BFormGroup)
  Vue.component('b-form-input', BFormInput)
  Vue.component('b-form-select', BFormSelect)
  Vue.use(FormCheckboxPlugin)
  Vue.use(LayoutPlugin)
  import permission from '../schools/associa-user-permission.vue'
  export default {
    name: 'registro-professor',
    props: ['company_id', 'escola'],

    components: {

      permission
      // Multiselect: () => import('vue-multiselect'),
    },

    data() {
      return {
        codigo_disciplina: '',
        perfil: '',
        eh_professor: true,
        gerarSenhaAutomatico: true,
        errormessages: [],
        showErrorToast: false,
        isSavingUser: false,
        createdUserId: null,
        userCreated: false,
        createdUser: null,
        generatedPassword: '',
        cad_codigos: false,
        nome: '',
        sobrenome: '',
        chk: false,
        c_chk: false,
        password: '',
        c_password: '',
        codigo_escola: '',
        codigo_mod: '',
        cpf: '',
        email: '',
        chk_aceite: false,
        sexo: '',
        professors: [],
        professorSelecionado: null,
        onprofessorSelect: null,
        onPerfilSelect: null,
        ondisciplinaSelect: null,
        sexos: [
          { name: 'Masculino', value: 'M' },
          { name: 'Feminino', value: 'F' },
          { name: 'Outro', value: 'O' },
        ],
        modalidade: [],
        discipline: [],
        perfis: [
          { id: 1, name: 'Bedel' },
          { id: 2, name: 'Coordenador(a)' },
          { id: 3, name: 'Docente' },
          { id: 4, name: 'Inspetor' },
          { id: 5, name: 'Mantenedor' },
          { id: 6, name: 'Master' },
          { id: 7, name: 'Outros' },
          { id: 8, name: 'Professor Auxiliar' },
          { id: 9, name: 'Secretario(o)' },
          { id: 10, name: 'Staff' },
          { id: 11, name: 'Supervisor(a)' },
        ],

        // Alterei aqui
        dismissSecs: 5,
        dismissCountDown: 0,
        showDismissibleAlert: false
      }
    },

    validations() {
      const validations = {
        nome: { required },
        sexo: { required },
        email: {
          required,
          email,
        },
        codigo_escola: { required },
      }

      if (this.eh_professor) {
        validations.codigo_mod = { required }
      }

      if (!this.eh_professor) {
        validations.perfil = { required }
      }

      if (!this.gerarSenhaAutomatico) {
        validations.password = {
          required,
          minLength: minLength(8),
        }
        validations.c_password = {
          required,
          sameAsPassword: sameAs(this.password),
        }
      }

      return validations
    },

    created() {
      // Preencher campos nome e email com base nos query parameters
      const { user_name, user_email } = this.$route.query
      if (user_name) {
        this.nome = decodeURIComponent(user_name)
      }
      if (user_email) {
        this.email = decodeURIComponent(user_email)
      }

      this.getModalidades()
      this.getDisciplinas()
    },

    mounted() {
      new WOW().init()
      this.codigo_escola = this.company_id?.toString() || ''
    },

    computed: {
      checkCpf() {
        return cpf.isValid(this.cpf)
      },

      disciplinaNome() {
        return this.discipline.map((m) => ({
          id: m.id,
          name: m.name,
        }))
      },

      modalidadeNome() {
        return this.modalidade.map((m) => ({
          id: m.id,
          name: m.name,
        }))
      },
      perfilNome() {
        return this.perfis.map((m) => m.name)
      },

      showPassword() {
        return this.chk ? 'text' : 'password'
      },
      showConfirmPassword() {
        return this.c_chk ? 'text' : 'password'
      },

            hasAdminRole() {
        const roles = this.$store?.state?.auth?.userpermissions?.permissions || []
        return roles.includes('p-super-admin')
      },
    },

    methods: {
      getModalidades() {
        ApiService.post(`schools/modalidade-turma-contratada`, {
          school_id: this.company_id,
        })
          .then((res) => {
            this.modalidade = res.data.modalidades
          })
          .catch((error) => {
            console.log(error)
            this.modalidade = []
          })
      },
      getDisciplinas() {
        ApiService.get(`schools/disciplinas`)
          .then((dis) => {
            this.discipline = Array.isArray(dis.data.disciplinas) ? dis.data.disciplinas : []
          })
          .catch((error) => {
            console.log(error)
            this.discipline = []
          })
      },

      next() {
        this.$v.$touch()
        if (this.$v.$invalid || this.checkCpf === false || this.password != this.c_password) {
          return
        }
      },
      associa() {
        ApiService.post(`schools/escola/vincular-existente-professor`, {
          school: this.company_id,
          email: this.email,
          id_modalidade: this.codigo_mod,
          disciplina_id: this.codigo_disciplina,
          perfil: this.perfil.name,
        })
          .then((res) => {
            this.professors = res.data
            this.$swal({
              title: 'Usuario associado',
              html: `O usuário <b>${this.email}</b> foi associado com sucesso na escola <b>${this.escola}</b>.`,
              text: 'Agora você pode acessar o sistema com esse usuário.',
              icon: 'success',
              allowOutsideClick: true,
              allowEscapeKey: true,
              allowEnterKey: true,
            }).then((result) => {
    
            })
          })
          .catch((error) => {
            let message = 'Algo errado no processo de associação'
            this.$swal({
              title: 'Erro',
              html: message,
              icon: 'error',
              allowOutsideClick: true,
              allowEscapeKey: true,
              allowEnterKey: true,
            }).then((result) => {
 
            })
            this.professors = []
          })
          .finally(() => {})
      },
      register() {
        this.$v.$touch()
        if (this.$v.$invalid) {
          return
        }

        this.isSavingUser = true
        this.errormessages = []

        this.userCreated = false
        this.createdUser = null
        this.generatedPassword = ''

        this.dismissCountDown = this.dismissSecs

       // Ajustar conforme  combinar as regrass de acesso


        ApiService.post('users/postCreateUser', {
          name: this.nome,
          cpf: this.cpf,
          email: this.email,
          sexo: this.sexo,
          birthday: '1900-01-01',
          turmaId: this.codigo_mod,
          selrole_id: 6,
          role_id: this.codigo_mod,
          school: this.company_id,
          team_id: null,
          company_id: this.company_id,
          registro_de: 'professor',
          id_modalidade: this.codigo_mod,
          perfil: this.perfil.name,
          discipline_id: this.codigo_disciplina,
        })
          .then((response) => {
            const data = response.data
            this.viewReturn = data

            if (data.status === 'success') {
              this.createdUserId = data.user.id
              this.userCreated = true

              this.createdUser = data.user
              this.generatedPassword = data.new_user_password

              this.resetForm()

              this.$swal({
                title: 'Usuário criado',
                html: `Anote a senha gerada automaticamente em local seguro, pois não poderá vê-la novamente.<br><strong>Senha:</strong> ${data.new_user_password}`,
                icon: 'success',
                allowOutsideClick: true,
                allowEscapeKey: true,
                allowEnterKey: true,
              }).then((result) => {
      
              })
            } else if (response.data.status === 'error') {
              this.errormessages = []

              if (response.data.errors) {
                for (const key in response.data.errors) {
                  this.errormessages.push(...response.data.errors[key])
                }
              } else {
                this.errormessages.push('Erro desconhecido. Verifique os dados.')
              }

              this.showErrorToast = true
            }
          })
          .catch((error) => {
            console.log(error)

            if (error.response && error.response.data.errors) {
              const errors = error.response.data.errors
              for (const key in errors) {
                if (errors[key]) {
                  this.errormessages.push(errors[key])
                }
              }
            } else {
              this.errormessages.push('Erro ao salvar: Ocorreu um problema ao salvar os dados.')
            }

            this.showErrorToast = true
          })
          .finally(() => {
            this.isSavingUser = false
          })
      },
      resetForm() {
        this.nome = ''
        this.sobrenome = ''
        this.cpf = ''
        this.email = ''
        this.chk_aceite = false
        this.sexo = ''
        this.codigo_escola = ''
        this.codigo_mod = 'null'
        this.password = ''
        this.c_password = ''
        this.$v.$reset()
      },
      // refreshPage() {
      //   window.location.reload()
      // },
      togglePasswordVisibility() {
        this.chk = !this.chk
      },
      toggleCPasswordVisibility() {
        this.c_chk = !this.c_chk
      },

      // Alterei aqui - Bruno
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs;
      }
    },
  }
</script>

<style scoped>
  @import '~vue-multiselect/dist/vue-multiselect.min.css';

  .admin-register {
    height: calc(100vh - 204px);
    display:flex;
    align-items: center;
  }

  ::v-deep .card {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  span.display-6 {
    font-size: 1.35rem;
  }

  /* CONTENT INFO LEFT */
  .image-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/images/cadastroResp.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  .image-background .dark-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    z-index: 1;
  }
  .content-info {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    z-index: 2;
  }
  .content-info .box-text {
    width: 100%;
    height: 100%;
    padding: 0 10px;
  }
  .content-info .box-text hr {
    border: 1px solid #373737;
    width: 100%;
  }
  .content-info .box-text p {
    font-size: 1rem;
    line-height: 22px;
    letter-spacing: 0px;
  }
  .content-info .box-text .btn-professor {
    /* border-radius: 24px; */
    background-color: #3a1c53;
    color: white;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 1.385px;
    text-transform: uppercase;
    padding: 8px 16px;
    transition: background-color 0.3s ease;
  }

  /* CONTENT FORM RIGHT */
  .box-form {
    width: 100%;
    height: 100%;
    padding: 40px 20px;
    display: flex;
    align-items: center;
  }
  .box-form .input-container {
    position: relative;
  }
  .box-form .input-container .icon {
    position: absolute;
    top: 28%;
    left: 15px;
    transform: translate(-50%);
    color: #3a1c53c6;
    font-size: 1rem;
    font-weight: 300;
    pointer-events: none;
  }
  .box-form .input-container .icon-right {
    position: absolute;
    top: 28%;
    right: 0px;
    transform: translate(-50%);
    color: #3a1c53c6;
    font-size: 1rem;
    font-weight: 300;
    pointer-events: auto;
    cursor: pointer;
    background-color: #f7f5f9;
  }
  .box-form .input-container ::v-deep .custom-input {
    padding: 0px 35px 0 35px;
    font-weight: 400;
    background-color: #f7f5f9;
    color: #3a1c53c6;
    border: 0px solid #3a1c5340;
    border-radius: 4px;
    transition: box-shadow 0.3s ease;
  }
  .box-form .input-container ::v-deep .custom-input-select {
    padding: 0px 25px 0 35px;
    font-weight: 400;
    background-color: #f7f5f9;
    color: #3a1c53c6;
    border: 0px solid #3a1c5340;
    border-radius: 4px;
    transition: box-shadow 0.3s ease;
  } 
  .box-form .input-container ::v-deep .custom-input::placeholder,
  .box-form ::v-deep .custom-control-label {
    color: #3a1c53c6;
  }
  .box-form .input-container ::v-deep .custom-input:focus,
  .box-form .input-container ::v-deep .custom-input-select:focus {
    box-shadow: 0 0 0 0.15rem rgba(58, 28, 83, 0);
  }
  .box-form ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    color: #3a1c53c6;
    border-color: #3a1c5340 !important;
    background: #f7f5f9 !important;
    transition: background 0.35s ease, content 0.35s ease, border-color 0.35s ease;
  }
  .box-form ::v-deep .custom-control-label::before {
    border-color: #3a1c5340 !important;
    background-color: #f7f5f9 !important;
    box-shadow: none;
  }
  .box-form ::v-deep .custom-control-label::after {
    position: absolute;
    top: 0.1rem;
    left: -1.30rem;
    display: block;
    width: 1rem;
    height: 1rem;
    background: 50% / 50% 50% no-repeat;
    border-color: #3a1c5340 !important;
  }
  .box-form ::v-deep .custom-control-input:checked ~ .custom-control-label::after {
    background-image: none;
    content: '\2713';
    font-size: 14px;
  }
  div.admin-register ::v-deep .form-control {
    line-height: 1 !important;
  }
  .box-form .btn-register {
    padding: 8px 16px;
    background-color: #3a1c53;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
  }
  .box-form .btn-register:hover {
    color: #fff;
  }
  .box-form .btn-register:focus {
    box-shadow: 0 0 0 0.2rem rgba(58, 28, 83, 0.25);
  }
</style>
